import { useAppDispatch } from 'store/hooks';
import mediaSelectors from '../selectors';
import mediaActions from '../actions';
import { useEffect } from 'react';
import { IApiGetLibraryMediaParam } from 'modules/media/interfaces/api';

const useGetLibraryLinks = (isLazy = false) => {
  const dispatch = useAppDispatch();
  const data = mediaSelectors.getDataLibraryLinks();

  const mutate = (params: IApiGetLibraryMediaParam) => {
    dispatch(mediaActions.getLibraryLinks.fetch(params));
  };

  useEffect(() => {
    if (!isLazy) {
      mutate({ page: 1, size: 10 });
    }
  }, []);

  return [data, mutate] as const;
};

export default useGetLibraryLinks;
